module.exports = __webpack_public_path__ + "img/ic_grade_Normal.60c16bb.png";